// The Financial overview's one money format. The full form is the shared formatter
// (utils/currency formatMoney: "£1,200.00", en-GB, two decimals, sign outside the symbol); the
// short form is for chart axes only ("£1.2k", "£300").
import { formatMoney, currencySymbol } from '../../utils/currency';

// Decision 72: the page's sums are in the business's base currency (currentUser.baseCurrency, else
// GBP); the page sets it once per render. A single invoice is formatted in its own currency.
let BASE = 'GBP';
export function setMoneyBase(code) { BASE = String(code || 'GBP').toUpperCase(); }
export const fmtMoney = (n, code) => formatMoney(n, code || BASE);

// "plus €1,200 and $300" for the currencies that are not the base (never added together).
export function plusOthers(map) {
  const parts = Object.entries(map || {}).filter(([, v]) => v).map(([c, v]) => formatMoney(v, c));
  if (!parts.length) return '';
  return `plus ${parts.length > 1 ? `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}` : parts[0]}`;
}

export function fmtMoneyShort(n) {
  const x = Number(n || 0);
  const sign = x < 0 ? '-' : '';
  const a = Math.abs(x);
  const sym = currencySymbol(BASE);
  if (a >= 1000) return `${sign}${sym}${(a / 1000).toFixed(a % 1000 === 0 ? 0 : 1).replace(/\.0$/, '')}k`;
  return `${sign}${sym}${a.toFixed(0)}`;
}
